export enum NavigationItemId {
    DETAILS = 'details',
    NOTES = 'notes',
    ACT48 = 'act48',
    FLEX = 'flex',
    APPROVAL = 'approval',
    QUESTIONNAIRE = 'questionnaire',
    EVIDENCE = 'evidence',
    FOLLOW_UP_QUESTIONNAIRE = 'followUpQuestionnaire',
    FOLLOW_UP_EVIDENCE = 'follow-up-evidence'
}